/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    TextField,
    Toolbar,
    Checkbox,
    FormControlLabel,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import React from 'react';
import { IFormularioProveedoresVistaProps } from '../interfaces';
const FormularioProveedoresVista: React.FunctionComponent<IFormularioProveedoresVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    proveedores,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'proveedores.agregarProveedores'
                                : 'proveedores.modificarProveedores'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="proveedores.descripcionProveedor" display="inline" />}
                        name="DescripcionProveedor"
                        onChange={cambiarInfoFomulario}
                        required
                        value={proveedores.DescripcionProveedor}
                        id={`DescripcionProveedor-${proveedores.ProveedorId}`}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={Number(proveedores.Estado) === 1 ? true : false}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="productos.estado" display="inline" />}
                        name="Estado"
                        id={`EstadoProveedores`}
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Grid container justifyContent="flex-end" spacing={2}>
                <Grid item>
                    <Button
                        onClick={cerrarFormulario}
                        color="secondary"
                        variant="contained"
                        id="boton-cancelarProveedores"
                    >
                        <Texto id="boton.cancelar"
                        />
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        onClick={accionCrearEditar}
                        color="primary"
                        variant="contained"
                        id="boton-guardarProveedores"
                    >
                        <Texto id="boton.guardar" />
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>
);

export default FormularioProveedoresVista;
